import { render } from "./universal.vue?vue&type=template&id=774ace2d&scoped=true"
import script from "./universal.vue?vue&type=script&lang=js"
export * from "./universal.vue?vue&type=script&lang=js"

import "./universal.vue?vue&type=style&index=0&id=774ace2d&scoped=true&lang=css"

import exportComponent from "D:\\myProgram\\cloud-storage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-774ace2d"]])

export default __exports__